type PersistedFetchOpts = {
  key?: string;
  watch?: any[];
  server?: boolean;
  headers?: Record<string, string>;
  credentials?: RequestCredentials;
  lazy?: boolean;
};

export async function usePersistedFetch<TData = any, TVars extends Record<string, any> = Record<string, any>>(operationName: string, variables: TVars = {} as TVars, opts: PersistedFetchOpts = {}) {
  const runtimeConfig = useRuntimeConfig();
  const apiUrl = runtimeConfig.public.biennale_base;

  const { currentLanguage } = useCurrentLanguage();

  const key = opts.key || `pqfetch:${operationName}:${JSON.stringify(variables)}`;

  const { data, pending, error, refresh } = await useAsyncData<TData>(
    key,
    async () => {
      const res: any = await $fetch(apiUrl, {
        method: 'POST',
        headers: {
          'content-type': 'application/json',
          'Content-Language': currentLanguage.value,
          ...(opts.headers || {}),
        },
        body: {
          operationName,
          variables,
        },
        credentials: opts.credentials ?? 'include',
      });

      if (res?.errors?.length) {
        throw new Error(res.errors[0].message || 'GraphQL Error');
      }
      return res?.data as TData;
    },
    {
      watch: opts.watch || [],
      server: opts.server ?? true,
      lazy: opts.lazy ?? false,
    }
  );

  return { data, pending, error, refresh };
}
